<div class="row" *ngIf="!isLoading">
    <div class="col-xs-12 px-0 mt-4">
        <div class="main-box mx-3">
            <div class="main-body">
                <ngx-datatable class="material manage-skills-datatable email-client-review-datatable" [columns]="clientReviewTableColumnHeading"
                    [rows]="reviewsList" [columnMode]="'force'" [headerHeight]="60"
                    [footerHeight]="50" [rowHeight]="'auto'" [reorderable]="false" [limit]="6">
                </ngx-datatable>
            </div>
        </div>
    </div>

    <div class="col-xs-12 text-right">
        <div class="clearfix">
            <button type="button" class="btn btn-danger mr-3" (click)="closeModal()">
                <span>Cancel</span>
            </button>
            <button type="submit" class="btn btn-primary mr-4" (click)="saveClientReview()" [disabled]="isLoading || reviewsList.length === 0">
                <span>Save</span>
            </button>
        </div>
    </div>
</div>
<div class="row" *ngIf="isLoading">
    <div class="col-xs-12">
        <app-skeleton-loader variant="block" [rows]="3"></app-skeleton-loader>
    </div>
</div>

<!-- Serial Number Template -->
<ng-template #serialNumberTemplate let-row="row">
    <span>{{row.serialNumber}}</span>
</ng-template>

<!-- Candidate Name Template -->
<ng-template #candidateNameTemplate let-row="row">
    <span>{{row.candidateName}}</span>
</ng-template>

<!-- Sent DateTime Template -->
<ng-template #sentDateTimeTemplate let-row="row">
    <span>{{row.sentDateTime}}</span>
</ng-template>

<!-- No of Days Template -->
<ng-template #noDaysTemplate let-row="row">
    <span>{{row.noDays}}</span>
</ng-template>

<!-- Step and State Template -->
<ng-template #stepAndStateTemplate let-row="row">
    <div class="mb-1">
        <span class="font-bold">Current Step</span>: {{row.stepAndState.currentStep}}
    </div>
    <div>
        <span class="font-bold">Current State</span>: {{row.stepAndState.currentState}}
    </div>
</ng-template>

<!-- Recipients Template -->
<ng-template #clientReviewRecipientsTemplate let-row="row">
    <div *ngIf="row.recipients && row.recipients.length > 0">
        <div class="mb-1" style="white-space: normal; text-wrap: wrap; word-wrap: break-word;"
            *ngFor="let recipient of row.recipients; let i = index;">
            <span>{{recipient}}</span>
        </div>
    </div>
    <div class="mb-1" style="white-space: normal; text-wrap: wrap; word-wrap: break-word;"
        *ngIf="!row.recipients || row.recipients.length === 0">
        <span>No recipients</span>
    </div>
    <!-- <div class="mb-1" style="white-space: normal; text-wrap: wrap;">
        <span [innerHTML]="row.recipients.toString().replaceAll(',', ', ')"></span>
    </div> -->
</ng-template>

<ng-template #clientReviewInformationSentTemplate let-row="row">
    <div *ngIf="row.informationSent === 'View' && row.hasClientReviewFields">
        <div class="text-overflow-ellipsis ml-1 font-bold">
            <span style="font-size: 12px;">
                <i class="fas fa-file-alt text-muted ml-1 mr-2"></i>
                <a class="cursor-pointer" (click)="viewEmailDetails(row)">View</a>
            </span>
        </div>
    </div>
    <div *ngIf="row.informationSent !== 'View' || !row.hasClientReviewFields">
        <span class="font-bold">Follow Up message</span>
    </div>
</ng-template>

<!-- Note Template -->
<ng-template #noteTemplate let-row="row">
    <div>
        <textarea name="{{row.id}}-note-id" class="form-control external-notes"
            [(ngModel)]="row.responseNote" (ngModelChange)="onNoteChange(row)" placeholder="Enter note">
        </textarea>
    </div>
</ng-template>

<!-- Response Received Template -->
<ng-template #responseReceivedTemplate let-row="row">
    <div class="d-flex justify-content-center align-items-center">
        <div class="checkbox-nice text-nowrap mb-2">
            <input type="checkbox" [(ngModel)]="row.responseReceived" id="{{row.id}}-response-id"
                name="{{row.id}}-response-id" (change)="onResponseCheckboxChange(row)" />
            <label for="{{row.id}}-response-id"></label>
        </div>
    </div>
</ng-template>

<!-- Email Details Popover Template -->
<ng-template #emailDetailsTemplate let-review="review">
    <div class="email-details-popover">
        <div *ngIf="review.emailDetails && review.emailDetails.clientReviewIncludeFields && review.emailDetails.clientReviewIncludeFields.length > 0">
            <div class="mb-2" *ngFor="let field of review.emailDetails.clientReviewIncludeFields">
                <div class="mb-1">
                    <span class="font-bold">{{field.fieldLabel}}</span>
                </div>
                <div>
                    <span>{{field.fieldValue}}</span>
                </div>
            </div>
        </div>
        <div *ngIf="!review.emailDetails || !review.emailDetails.clientReviewIncludeFields || review.emailDetails.clientReviewIncludeFields.length === 0">
            <span>No information sent</span>
        </div>
    </div>
</ng-template>

<!-- Email Details Modal Template -->
<ng-template #emailDetailsModalTemplate>
    <div class="modal-header" style="padding: 15px !important; border-bottom: 1px solid #e5e5e5;">
        <button type="button" class="close" data-dismiss="modal" aria-hidden="true"
            (click)="closeEmailDetailsModal()">×</button>
        <h4 class="modal-title wrap-text-in ng-binding">Email Details</h4>
    </div>

    <div class="modal-body">
        <div class="row">
            <div class="col-xs-12 px-4">
                <div class="clearfix">
                    <div style="max-height: 500px; overflow: auto;">
                        <div *ngIf="currentEmailDetails">

                            <div class="panel panel-default mb-0">
                                <div class="panel-heading">
                                    <h5 class="panel-title font-bold">
                                        <i class="fas fa-envelope mr-2"></i>Email Sent
                                    </h5>
                                </div>
                                <div class="panel-body">
                                    <div class="mb-4">
                                        <span class="font-bold">Sent Date Time:</span>
                                        <span class="ml-2">{{ currentEmailDetails.sentDateTime }}</span>
                                    </div>
                                    <div class="mb-4">
                                        <div class="font-bold mb-1">Subject</div>
                                        <div class="border p-2">
                                            {{ currentEmailDetails.subject }}
                                        </div>
                                    </div>
                                    <div>
                                        <div class="font-bold mb-1">Body</div>
                                        <div class="border p-2">
                                            <div [innerHtml]="currentEmailDetails.body"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="text-center" style="margin: 18px 0;">
                                <div style="display: flex; align-items: center; gap: 10px;">
                                    <div style="flex: 1; border-top: 2px dashed #aaa;"></div>
                                    <div style="flex: 1; border-top: 2px dashed #aaa;"></div>
                                </div>
                            </div>

                            <div class="panel panel-default mb-4">
                                <div class="panel-heading">
                                    <h5 class="panel-title font-bold">
                                        <i class="fas fa-user mr-2"></i>Candidate information at the time of email being sent
                                    </h5>
                                </div>
                                <div class="panel-body-candidate">
                                    <div *ngIf="currentEmailDetails.fields && currentEmailDetails.fields.length > 0">
                                        <table class="table table-bordered table-sm mb-0">
                                            <tbody>
                                                <tr *ngFor="let field of currentEmailDetails.fields">
                                                    <td class="font-bold" style="width: 40%;">{{ field.fieldLabel }}</td>
                                                    <td>{{ field.fieldValue }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div *ngIf="!currentEmailDetails.fields || currentEmailDetails.fields.length === 0">
                                        <p class="text-muted mb-0">No candidate information was sent in this email.</p>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div *ngIf="!currentEmailDetails">
                            No email details available.
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="modal-footer">
        <button type="button" class="btn btn-danger" data-dismiss="modal" (click)="closeEmailDetailsModal()">
            Close
        </button>
    </div>
</ng-template>
